import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Contactpersoon } from '../types/Contactpersoon'

export { createContactpersoonForEntity }

async function createContactpersoonForEntity({
  contactpersoon,
  entity,
}: {
  contactpersoon: Contactpersoon
  entity: Entity
}): Promise<Contactpersoon> {
  const { type, id } = entity

  const { data } = await apiClient({
    url: `/rest/${type}/${id}/contactpersoon`,
    method: 'POST',
    data: contactpersoon,
  })

  return data
}
